// @flow
import * as React from 'react';
import './ElementsHeading.scss';

type ElementsHeadingProps = {|
  children: React.Node,
|};

export const ElementsHeading = ({children}: ElementsHeadingProps) => {
  return <div className="ElementsHeading">{children}</div>;
};
